import { client } from '../client';
import { UserProfile } from './types/UserProfile';

type UpdatePracticePayload = {
  practice_ids: string[];
};

export const updateUserPractice = async (
  user_id: number,
  payload: UpdatePracticePayload,
  userRole?: string,
): Promise<UserProfile> => {
  const prefix =
    userRole === 'CareAdvisor' ? '/care_advisor' : userRole === 'Collector' ? '/collector' : '/admin';
  const { data } = await client.patch(`${prefix}/users/${user_id}/practices`, payload);

  return data;
};
